<script lang="ts">
import { PropType } from "vue"
import { AlarmLevel } from "@/types/alarm"
import { levelIconClass, levelVariant } from "@/utils/alarm-utils"

export default {
    name: "AlarmLevelIcon",
    props: {
        level: {
            type: String as PropType<AlarmLevel>,
            required: true,
        },
        large: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        iconClass(): string {
            return levelIconClass(this.level)
        },
        variantClass(): string {
            return `alarm-level-icon--${levelVariant(this.level)}`
        },
    },
}
</script>

<template>
    <i
        class="alarm-level-icon"
        :class="[iconClass, variantClass, { 'alarm-level-icon--large': large }]"
    ></i>
</template>

<style lang="scss" scoped>
.alarm-level-icon {
    flex-shrink: 0;
    font-size: 1.25rem;
    line-height: 1.3;

    &--large {
        font-size: 1.5rem;
    }

    &--danger {
        color: var(--toast-danger-accent);
    }
    &--warning {
        color: var(--toast-warning-accent);
    }
    &--info {
        color: var(--toast-info-accent);
    }
    &--secondary {
        color: var(--theme-auxiliary);
    }
}
</style>
